import { type IFairValueInstrument, HEDGING_SECTIONS } from './types'

const sectionOptions = HEDGING_SECTIONS.reduce(
  (acc, { key, label }) => ({ ...acc, [key]: label }),
  {} as Record<string, string>,
)

export const fairValueInstrumentInputs = (form: Partial<IFairValueInstrument>): Record<string, any> => ({
  section: {
    inputType: 'select',
    title: 'Section',
    options: sectionOptions,
    value: form.section,
    hasDefaultOption: true,
    require: true,
  },
  instrument: { inputType: 'text', title: 'Instrument', value: form.instrument, required: true },
  reference: { inputType: 'text', title: 'Reference / Loan', value: form.reference, span: 'full' },
  notional: { inputType: 'text', type: 'number', title: 'Notional', value: form.notional ?? '' },
  fvGlAccountNo: { inputType: 'text', title: 'FV GL Acct', value: form.fvGlAccountNo, required: true },
  fairValue: { inputType: 'text', type: 'number', title: 'Fair Value', value: form.fairValue },
})
